export default __webpack_public_path__ + "img/filter_BW.f3d2c890c0134009b63e0d7d67a131af.jpg";